module.exports = __webpack_public_path__ + "static/media/investment_hand.de182a21.svg";